import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ProgressLine } from './ProgressLine';
import PersonalData from './PersonalData';
import { TDirectorInfo } from '../../../types';
import { ResidentialDetails } from './ResidentialDetails';
import {
  validateInputsResultOne,
  validateInputsSecond,
  validateInputsThirdStage,
} from '../../../utils/ValidateShareholderInfo';
import DocumentUpload from './DocumentUpload';
import UploadedDocs from './UploadedDocs';

type TProps = {
  shareholders: TDirectorInfo[];
  currentShareholder: number;
  setShareholders: React.Dispatch<React.SetStateAction<TDirectorInfo[]>>;
  setCurrentShareholder: React.Dispatch<React.SetStateAction<number>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};
const ShareHolder = ({
  currentShareholder,
  shareholders,
  setCurrentShareholder,
  setStep,
  setShareholders,
}: TProps) => {
  const [activeStage, setActiveStage] = useState(1);
  const stageOne = useMemo(() => {
    return validateInputsResultOne(shareholders, currentShareholder);
  }, [shareholders, currentShareholder]);
  const stageTwo = useMemo(() => {
    return validateInputsSecond(shareholders, currentShareholder);
  }, [shareholders, currentShareholder]);
  const stageThree = useMemo(() => {
    return validateInputsThirdStage(shareholders, currentShareholder);
  }, [shareholders, currentShareholder]);

  useEffect(() => {
    setActiveStage(1);
  }, [currentShareholder]);
  return (
    <div>
      <ProgressLine
        active={activeStage}
        isStageOneComplete={stageOne}
        isStageTwoComplete={stageTwo}
        isStageThreeComplete={stageThree}
        setActive={setActiveStage}
      />
      {activeStage === 1 && (
        <PersonalData
          currentShareholder={currentShareholder}
          shareholders={shareholders}
          setActiveStage={setActiveStage}
          activeStage={activeStage}
          setShareholders={setShareholders}
          isStageOneComplete={stageOne}
          setCurrentShareholder={setCurrentShareholder}
        />
      )}

      {activeStage === 2 && (
        <ResidentialDetails
          isStageTwoComplete={stageTwo}
          currentShareholder={currentShareholder}
          shareholders={shareholders}
          setActiveStage={setActiveStage}
          activeStage={activeStage}
          setShareholders={setShareholders}
        />
      )}

      {activeStage === 3 && (
        <DocumentUpload
          isStageThreeComplete={stageThree}
          currentShareholder={currentShareholder}
          shareholders={shareholders}
          setActiveStage={setActiveStage}
          activeStage={activeStage}
          setShareholders={setShareholders}
        />
      )}

      {activeStage === 4 && (
        <UploadedDocs
          shareholder={shareholders[currentShareholder]}
          setActiveStage={setActiveStage}
          setCurrentShareholder={setCurrentShareholder}
          shareholders={shareholders}
          currentShareholder={currentShareholder}
          setStep={setStep}
        />
      )}
    </div>
  );
};

export default ShareHolder;
